import { render, staticRenderFns } from "./jinZhiReportMenu.vue?vue&type=template&id=68dcb787&scoped=true&"
import script from "./jinZhiReportMenu.vue?vue&type=script&lang=js&"
export * from "./jinZhiReportMenu.vue?vue&type=script&lang=js&"
import style0 from "./jinZhiReportMenu.vue?vue&type=style&index=0&id=68dcb787&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dcb787",
  null
  
)

export default component.exports